import { Link } from 'react-router-dom';
import { categoryEntries } from '@/mocks/home';

const accentStyles: Record<string, { bg: string; text: string; ring: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', ring: 'group-hover:border-primary-300' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-800', ring: 'group-hover:border-accent-300' },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-800',
    ring: 'group-hover:border-secondary-300',
  },
};

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {categoryEntries.map((entry) => {
        const style = accentStyles[entry.accent] ?? accentStyles.primary;
        return (
          <Link
            key={entry.key}
            to={entry.link}
            className={`group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors ${style.ring}`}
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg ${style.bg} ${style.text}`}
            >
              <i className={`${entry.icon} text-2xl`} aria-hidden="true"></i>
            </span>
            <span className="min-w-0 flex-1">
              <span className="block font-heading text-lg font-bold text-foreground-950">
                {entry.title}
              </span>
              <span className="mt-1 block text-sm leading-relaxed text-foreground-600">
                {entry.description}
              </span>
            </span>
            <i
              className="ri-arrow-right-line text-xl text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-primary-600"
              aria-hidden="true"
            ></i>
          </Link>
        );
      })}
    </div>
  );
}